var map = {
	"./_next.png": 1334,
	"./_prev.png": 1335,
	"./agpaginationbtn/btFirst.svg": 1336,
	"./agpaginationbtn/btLast.svg": 1337,
	"./agpaginationbtn/btNext.svg": 1338,
	"./agpaginationbtn/btPrevious.svg": 1339,
	"./bed-outline.png": 1340,
	"./c5.jpg": 1341,
	"./c6.jpg": 857,
	"./c7.jpg": 1342,
	"./c9.jpg": 1343,
	"./calendar-outline.png": 1344,
	"./calendar-outline1.png": 262,
	"./calendar.png": 856,
	"./caro3.jpg": 1345,
	"./caro7.jpg": 1346,
	"./caro8.jpg": 1347,
	"./check.png": 887,
	"./close_icon.png": 575,
	"./cloud-computing.png": 619,
	"./defaultRoom.png": 1348,
	"./defaultRoomImg.png": 1349,
	"./details.png": 1350,
	"./dropcloseicon.png": 861,
	"./dropcloseicon1.png": 1351,
	"./guesthouse.jpg": 1352,
	"./happy.png": 889,
	"./hero-banner1.png": 930,
	"./highlights_tick.png": 541,
	"./homestay.png": 1353,
	"./hotel.png": 265,
	"./imageIcon.png": 1354,
	"./location.png": 1355,
	"./location1.png": 862,
	"./loginIcon.png": 1356,
	"./next.png": 859,
	"./no-icon.png": 1357,
	"./no-icon1.png": 91,
	"./no-picture.jpg": 375,
	"./pencilColor.png": 865,
	"./people-outline.png": 1358,
	"./people-outline1.png": 863,
	"./pls.png": 656,
	"./prev.png": 858,
	"./profile-back.png": 603,
	"./qr-code.png": 1359,
	"./resetIcon.png": 1360,
	"./searchicon.png": 1361,
	"./searchicon1.png": 620,
	"./shield.png": 1362,
	"./smartphone1.png": 1363,
	"./smartphone2.png": 1364,
	"./stateLoaderImage.png": 353,
	"./staticmap.png": 871,
	"./staying-pic-arunachal.png": 1365,
	"./staying-pic-meghalaya.png": 1366,
	"./staying-pic-odisha.png": 1367,
	"./staying-pic-sikkim.png": 1368,
	"./staying-pic-tamil-nadu.png": 1369,
	"./staying-pic-west-bengal.png": 1370,
	"./stayingLogo.png": 580,
	"./stayingLogoNew.png": 539,
	"./stayingLogoWhite.png": 588,
	"./tickicon.png": 1371,
	"./toastify/bell.png": 890,
	"./toastify/error.png": 1372,
	"./toastify/errorimg.png": 891,
	"./toastify/info.png": 892,
	"./toastify/information.png": 893,
	"./toastify/success.png": 1373,
	"./toastify/successimg.png": 894,
	"./toastify/warning.png": 1374,
	"./toastify/warnningIcon.png": 895,
	"./trendingImg1.png": 928,
	"./trendingImg2.png": 1375,
	"./trendingImg3.png": 1376,
	"./trendingImg4.png": 1377,
	"./trendingImg5.png": 1378,
	"./trendingImg6.png": 1379,
	"./trendingImg7.png": 1380,
	"./unapprovedicon.png": 1381,
	"./updateIcon.png": 866,
	"./uploadFile.png": 1382,
	"./usericon.png": 853,
	"./vietnam.jpg": 1383,
	"./warning.png": 1384,
	"./zoom-in.png": 578,
	"./zoom-out.png": 579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;